module.exports = __webpack_public_path__ + "static/media/3.787d2599.jpg";